module.exports = __webpack_public_path__ + "static/media/transactionImg.64025e69.svg";